import { lazy } from 'react';

const AssetsPage = lazy(() => import('../pages/Assets.page'));
const AddAssetPage = lazy(() => import('../pages/AddAsset.page'));

const AssetsRoutes = [
    {
        path: '/assets',
        element: <AssetsPage />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/assets/add',
        element: <AddAssetPage />,
        layout: 'default',
        isAuthReq: true,
    },
];

export { AssetsRoutes };
